<template>
    <div class="MlivingVideoView tc-black">
        <div class="video-box flex-center" oncontextmenu="return false;">
            <video :src="item.csfileurl" oncontextmenu="return false;" class="video" controls controlslist="nodownload"></video>
        </div>
        <div class="intro tc-grey">
            <div class="subject blod tc-black">{{item.subject}}</div>
            <div class="datetime">发布于：{{item.datetime}}</div>
            <div class="desc">{{item.description}}</div>
        </div>
        <div class="recommed-box living-container">
            <div class="title-box flex-between">
                <div class="title blod">推荐视频</div>
                <div class="more tc-grey" @click="handleTopic">更多></div>
            </div>
            <div class="box flex-start flex-top" v-for="(obj,i) in recommendlist" :key="i" @click="handleClick(obj)">
                <div class="left img-box"><img v-lazy="obj.coverurl" alt="" class="img"></div>
                <div class="right text-ellipses blod flex-grow flex-top">{{obj.subject}}</div>
            </div>
        </div>
        <div class="comment-box living-container">
            <div class="title-box flex-between">
                <div class="title blod">评论区</div>
            </div>
            <pull :pull="pull" :page="page" @getList="_getList">
                <div class="live_list_warp">
                    <div class="content-box">
                        <div class="box" v-for="(obj,i) in dataList" :key="i">
                            <div class="top flex-start">
                                <div class="left img-box">
                                    <img v-lazy="obj.customeratturl" alt="" class="img">
                                </div>
                                <div class="right flex-between">
                                    <div class="name">{{obj.customername}}</div>
                                    <div class="date tc-grey">{{obj.datetime}}</div>
                                </div>
                            </div>
                            <div class="bottom tc-gray flex-start">
                                <div class="left img-box"></div>
                                <div class="content">{{obj.content}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </pull>
        </div>
        <div class="oper flex-between tc-grey" v-show="!isEdit">
            <div class="left">
                <span class="icon icon-m-edit2 edit flex-start" @click="handleOpenEdit">写评论</span>
            </div>
            <div class="right flex-end">
                <span class="icon-m-comment2 icon comment flex-start" @click="handleComment">{{item.comentcount}}</span>
                <span class="icon-m-zan2 icon zan flex-start" :class="[item.ispraise==1?'select':'']" @click="handleZan">{{item.praisecount}}</span>
                <span class="icon-m-collect2 icon collect flex-start" :class="[item.isfavorite==1?'select':'']" @click="handleCollect"></span>
                <span class="icon-m-share2 icon share flex-start" @click="handleShare" v-if="_isWixin()"></span>
            </div>
        </div>
        <div class="join-box" v-show="isEdit">
            <van-field v-model="content" rows="3" autosize type="textarea" maxlength="200" placeholder="说点什么吧…" show-word-limit />
            <div class="flex-end btn-box">
                <van-button type="primary" @click="handleCancel">返回</van-button>
                <van-button type="info" @click="handleComment">评论</van-button>
            </div>
        </div>
        <sharePopup ref="sharePopup"></sharePopup>
    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {getVedioDetailByTopic, getCommentList, updateCommentInfo, getRecommendVedioByTopic} from 'api/web-app'
  import {addPraiseInfo} from 'api/pcvideo.js'
  import {uploadCourseFavorite} from 'api/public'
  import {getWXSDKSetting} from 'common/js/wxSDKSetting'
  import Pull from 'views/mobile/components/pull/pull'
  import $ from 'jquery'
  import sharePopup from 'views/Mlive/livingVideo/components/livingSharePop.vue'
  export default {
    name: 'MlivingVideoView',
    data() {
      return {
        isEdit: false,
        dataList: [],
        topicid: '',
        param: {
          kmcinnerid: this.$route.query.kmcinnerid ? this.$route.query.kmcinnerid : '',
          datacount: 3
        },
        recommendlist: [],
        content: '',
        page: {
          page: 1,
          pagesize: 10,
          pageCount: 0,
          rowCount: 0
        },
        pull: {
          isLoading: false,
          loading: false,
          error: false,
          finished: false
        },
        item: {
          comentcount: 0,
          content: '',
          coverurl: '',
          csfileurl: '',
          datetime: '',
          description: '',
          favoritedcount: 0,
          feetype: 1,
          hostid: '',
          hostname: '',
          iscommen: 0,
          isfavorite: 0,
          isjoin: 0,
          ispraise: 0,
          kmcinnerid: '',
          praisecount: 0,
          saleprice: '',
          sharecontent: '',
          subject: '',
          uprice: '',
          viewcount: 0,
        }
      }
    },
    created() {
      if(!this.domainInfo.isMobile){
        this.$router.replace({name: 'livingVideoView', query: {kmcinnerid: this.param.kmcinnerid}})
      }
    },
    mounted() {
      $('html').scrollTop(0)
      if (!this.refresh) {
        this._initView()
      }
    },
    activated() {
      if (this.refresh) {
        this.param.kmcinnerid = this.$route.query.kmcinnerid
        this._initView()
      }
    },
    methods: {
      _initView() {
        this.isEdit = false
        this.page = {
          page: 1,
          pagesize: 10,
          pageCount: 0,
          rowCount: 0
        }
        this.pull = {
          isLoading: false,
          loading: false,
          error: false,
          finished: false
        }
        this._getView()
        this._getList()
        this._getRecommedList()
      },
      handleClick(obj) {
        this.$router.push({name: 'MlivingVideoView', query: {kmcinnerid: obj.kmcinnerid}})
        this.param.kmcinnerid = obj.kmcinnerid
        this._getView()
        this._getList()
        this._getRecommedList()
      },
      handleOpenEdit() {
        this.isEdit = true
      },
      handleComment() {
        if (this.user.isLogin) {
          if (!this.content) {
            this.$toast.fail('请输入讨论内容')
          } else {
            this._add()
          }
        }
      },
      handleCancel() {
        this.isEdit = false
      },
      handleTopic() {
        this.$router.push({name: 'MlivingVideoList', query: {hostinnerid: this.item.hostid, hostname: this.item.hostname}})
      },
      _isWixin() {
        let ua = window.navigator.userAgent.toLowerCase()
        if (/micromessenger/.test(ua)) {
          return true
        } else {
          return false
        }
      },
      handleShare() {
        if (this._isWixin()) {
        //   let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?kmcinnerid=' + this.item.kmcinnerid
        //   getWXSDKSetting({
        //     title: this.item.subject,
        //     desc: this.item.sharecontent,
        //     link: link,
        //     imgUrl: this.item.coverurl,
        //   })
          this.$refs.sharePopup.open()
        }
      },
      handleZan() {
        let ispraise = this.item.ispraise == 1 ? 2 : 1
        this.setLoading(true)
        addPraiseInfo({
          data: {kmcinnerid: this.item.kmcinnerid, kmctype: 4, optype: ispraise},
          success: () => {
            this.setLoading(false)
            if (ispraise == 2) {
              this.$toast.success('取消成功')
              this.item.praisecount--
              this.item.ispraise = 0
            } else {
              this.$toast.success('收藏成功')
              this.item.praisecount++
              this.item.ispraise = 1
            }
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      handleCollect() {
        let isfavorite = this.item.isfavorite == 1 ? 2 : 1
        this.setLoading(true)
        uploadCourseFavorite({
          data: {optype: isfavorite, courseid: this.item.kmcinnerid, kmctype: 4},
          success: () => {
            if (isfavorite == 2) {
              this.$toast.success('取消成功')
              this.item.favoritedcount--
              this.item.isfavorite = 0
            } else {
              this.$toast.success('点赞成功')
              this.item.favoritedcount++
              this.item.isfavorite = 1
            }
            this.setLoading(false)
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      _add() {
        this.setLoading(true)
        updateCommentInfo({
          data: Object.assign({}, {content: this.content}, this.param),
          success: () => {
            this.setLoading(false)
            this.$toast.success('发布成功')
            this.content = ''
            this.page.page = 1
            this.isEdit = false
            this._getList()
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      _getRecommedList() {
        this.setLoading(true)
        getRecommendVedioByTopic({
          data: Object.assign({}, this.param),
          success: data => {
            this.setLoading(false)
            this.recommendlist = data.data.content
            this.topicid = data.data.topicid
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      _getList() {
        this.setLoading(true)
        getCommentList({
          data: Object.assign({}, this.param, this.page),
          success: data => {
            this.init = true
            if (this.page.page === 1) {
              this.pull.isLoading = false
              this.dataList = data.data.commentinfo
            } else {
              this.dataList = this.dataList.concat(data.data.commentinfo)
            }
            this.setLoading(false)
            this.pull.loading = false
            this.page.pageCount = data.data.pageinfo.pageCount
            this.page.rowCount = data.data.pageinfo.rowCount
            if (this.page.page === this.page.pageCount) {
              this.pull.finished = true
            }
          },
          error: data => {
            this.setLoading(false)
            this.pull.error = true
            this.pull.loading = false
            this.$toast.fail(data.msg)
          }
        })
      },
      _getView() {
        this.setLoading(true)
        getVedioDetailByTopic({
          data: this.param,
          success: data => {
            this.item= data.data
            this.setLoading(false)
            document.title = this.item.subject

             if (this._isWixin()) {
                // Toast('微信分享')
                // let link = `http://ke.capwhale.com/courseView?cid=${this.$route.query.cid}`
                let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?kmcinnerid=' + this.item.kmcinnerid
                getWXSDKSetting({
                    title: this.item.subject,
                    desc: this.item.sharecontent,
                    link: link,
                    imgUrl: this.item.coverurl,
                })
            }
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions([
        'setLoading', 'setNoDataTip'
      ])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters(['user', 'domainInfo'])
    },
    components: {Pull, sharePopup}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .MlivingVideoView {
        padding-bottom: 1.52rem;
        .pull .van-list__finished-text{
            background: #fff;
        }
        .video-box{
            width: 7.5rem;
            height: 4.2rem;
            background: #000;
            .video{
                max-width: 100%;
                max-height: 100%;
            }
        }
        .living-container{
            background: #fff;
            padding: 0 0.32rem 0.16rem 0.32rem;
            .title-box{
                border-top: 0.01rem solid #E5E5E5;
                padding: 0.32rem 0 0.16rem 0;
                line-height: 0.4rem;
                .title{
                   font-size: 0.28rem;
                }
                .more{
                    font-size: 0.26rem;
                }
            }
        }
        .intro{
            background: #fff;
            padding: 0.32rem;
            .subject{
                font-size: 0.32rem;
                line-height: 0.45rem;
            }
            .datetime{
                font-size: 0.28rem;
                line-height: 0.4rem;
                margin: 0.2rem 0;
            }
        }
        .recommed-box{
            background: #fff;
            .box{
                padding: 0.16rem 0;
                .img-box{
                    width: 2.83rem;
                    height: 1.33rem;
                    min-width: 2.38rem;
                    max-width: 2.38rem;
                    .img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .right{
                    padding-left: 0.2rem;
                    font-size: 0.28rem;
                    line-height: 0.42rem;
                    word-break:break-all;
                }
            }
        }
        .comment-box{
            .content-box{
                .box{
                    padding: 0.32rem 0;
                    border-bottom: 0.01rem solid #E5E5E5;
                    .img-box{
                        margin-right: 0.2rem;
                        width: 0.8rem;
                        min-width: 0.8rem;
                        height: 0.8rem;
                        border-radius: 50%;
                        overflow: hidden;
                        .img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .top,.bottom{
                    .right{
                        .name{
                            font-size: 0.28rem;
                        }
                        .date{
                            font-size: 0.24rem;
                        }
                    }
                    .content{
                        font-size: 0.26rem;
                        line-height: 0.4rem;
                    }
                }
            }
        }
        .join-box{
            position: fixed;
            padding: 0.2rem 0.32rem 0 0.32rem;
            bottom: 0;
            left: 0;
            right: 0;
            background: #fff;
            .van-cell{
                background: #F5F7FA;
                border-radius: 6px;
            }
            .btn-box{
                height: 0.92rem;
                .van-button{
                    width: 1.24rem;
                    height: 0.52rem;
                    border-radius: 0.06rem;
                    font-size: 0.28rem;
                    border-width: 0;
                    line-height: 0.52rem;
                }
            }
            .van-button--normal{
                color: #409EFF;
                background: #E1EDFF;
            }
            .van-button--info{
                margin-left: 0.2rem;
                background: #409EFF;
                color: #fff;
            }
        }
        .oper{
            position: fixed;
            padding: 0 0.32rem;
            bottom: 0;
            left: 0;
            right: 0;
            height: 0.92rem;
            background: #fff;
            .icon:before{
                width: 0.44rem;
                height: 0.44rem;
            }
            .icon+.icon{
                margin-left: 0.4rem;
            }
            .edit,.comment,.zan{
                &:before{
                    margin-right: 0.08rem;
                }
            }
            .left{
                font-size: 0.26rem;
            }
            .right{
                font-size: 0.3rem;
            }
        }
    }
</style>